/**
 * @generated SignedSource<<84716b23872d6ef2cff9c61d2e6aca4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useInitializeRequestBookingWizardSession$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly firstName?: string | null | undefined;
      readonly id?: string;
      readonly lastName?: string | null | undefined;
      readonly membershipType: {
        readonly id: string;
      } | null | undefined;
      readonly profileImage?: {
        readonly publicId: string;
      } | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"useGetRequiredWizardSteps">;
  } | null | undefined;
  readonly " $fragmentType": "useInitializeRequestBookingWizardSession";
};
export type useInitializeRequestBookingWizardSession$key = {
  readonly " $data"?: useInitializeRequestBookingWizardSession$data;
  readonly " $fragmentSpreads": FragmentRefs<"useInitializeRequestBookingWizardSession">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Image",
    "kind": "LinkedField",
    "name": "profileImage",
    "plural": false,
    "selections": [
      {
        "alias": "publicId",
        "args": null,
        "kind": "ScalarField",
        "name": "renderingKey",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useInitializeRequestBookingWizardSession",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useGetRequiredWizardSteps"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "membershipType",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "Member",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "Customer",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
})();

(node as any).hash = "056d580588d5f305e6a29279636a7e7f";

export default node;
